import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

const TagIcon = ({ color = '#0d84fe', size = '16', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M15.4.5c-.3-.3-.8-.5-1.3-.5L9.4.2c-.8 0-1.4.3-2 .8L.7 7.8c-.9.9-.9 2.3 0 3.2L5 15.3c.4.5 1 .7 1.6.7s1.2-.2 1.6-.7L15 8.5c.5-.5.8-1.2.9-1.9l.1-4.7c0-.5-.2-1-.6-1.4zm-4 6.1c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2c.1 1.1-.8 2-2 2z"
      fill={color}
    />
  </svg>
);

TagIcon.propTypes = propTypes;

export default TagIcon;
